import { handleResponse } from '../Helpers/handle-response';
import * as apiHelper from '../Helpers/apiHelper';
import Base64 from '../Helpers/base64';

export const dataService = {
    getProductionOrdersByMachine,
    getAllProductionOrdersByMachine,
    getAllProductionOrdersByIdList,
    getProductionOrdersByCarpentryMachine,
    getProductionOrdersBySearchText,
    getProductionOrdersByCarpentrySearchText,
    getOrderDetailsByOrderId,
    getSystemParameterById,
    getSystemParametersByIdList,
    getMachineInAssignedByMachineId,
    getMachinesWithScissorStatusInfo,
    getMachineByCode,
    assignQuantityAtMachine,
    deleteMachineInAssignedById,
    updateZones,
    startProductionOrderLine,
    pauseProductionOrderLine,
    stopProductionOrderLine,
    finishProductionOrderLine,
    getMaterials,
    getArticles,
    pauseOrderById,
    startOrderById,
    getProductionOrderLineBOMOutProducedByBOMOutId,
    createBookingForProductionOrder,
    getQualitySamplesByBarcode,
    saveQualitySamples,
    getQualitySamplesByProductionOrderId,
    GetCheckNumberForPallet,
    machineStoppedReason,
    machineStoppedReasonNodeRED,
    saveNotification,
    getLatestNotifications,
    GetBookingSequenceByProductionOrderIdAndBarcode,
    GetLastWeight,
    getTransportOrdersHistory,
    getActiveTransportOrders,
    createNewBooking,
    getMachineSettingsByMachineId,
    saveMachineSetting,
    getOperators,
    getMachineParameters,
    getMachinesByMachineType,
    getSilos,
    getQualityChecks,
    getQualityCheckTypes,
    getQualityCheckOrders,
    validateAndHasRole,
    getProductionOrderLineStateHistory,
    getArticleInfoByBarcode,
    saveOPCNotification,
    getAllUsersWithDetails,
    saveUser,
    getAllRoles,
    restartScale,
    restartRecycleScale,
    resyncOrders,
    getZoneDivisions,
    saveZoneDivisions,
    getWeightForLineNumber,
    getWeightForRecycle,
    switchRawMaterialForOrder,
    GetOriginalRawMaterialBoms,
    GetIsBookingCritical,
    LogStandStillStart,
    LogStandStillStop,
    GetStopReasons,
    getProductionStateByMachineId,
    updateProductionStateOrderLog,
    getScrapColors,
    getScrapCarrierTypes,
    getScrapMaterialTypes,
    getRecyclingHistory,
    postRecyclingHistoryEntry,
    carrierExists,
    getWasteLocations,
    addOperatorCommentToOrderlineMetaData,
    getOperatorComments,
};

//in backend => order by ScheduledOn
function getProductionOrdersByMachine(machineId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_PRODUCTIONORDERSBYMACHINE);
    url += `?machineId=${machineId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getAllProductionOrdersByMachine(machineId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLPRODUCTIONORDERSBYMACHINE);
    url += `?machineId=${machineId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}


function getAllProductionOrdersByIdList(ids) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader(),
        },
        body: JSON.stringify(ids)
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETPRODUCTIONORDERSIDLIST);


    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getProductionOrdersByCarpentryMachine(machineId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_PRODUCTIONORDERSBYCARPENTRYMACHINE);
    url += `?machineId=${machineId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getProductionOrdersBySearchText(searchText) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_PRODUCTIONORDERSBYSEARCHTEXT);
    url += `?searchText=${searchText}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getProductionOrdersByCarpentrySearchText(searchText) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_PRODUCTIONORDERSBYCARPENTRYSEARCHTEXT);
    url += `?searchText=${searchText}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getOrderDetailsByOrderId(Id) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_ORDERDETAILS);
    url += `?Id=${Id}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getSystemParameterById(systemParameterId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_SYTEMPARAMETER);
    url += `${systemParameterId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getSystemParametersByIdList(systemParameterIds) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let idString = ""
    for (var id of systemParameterIds) {
        idString += String(id) + ","
    }
    idString = idString.substring(0, idString.length - 1);
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETSYTEMPARAMETERSBYIDLIST);
    url += `?ids=${idString}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}
function assignQuantityAtMachine(materials, machineId, productionOrderId) {

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify({
            ProductionOrderId: productionOrderId,
            MachineId: machineId,
            Materials: materials
        })
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_ASSIGNQUANTITYATMACHINE);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getMachineInAssignedByMachineId(machineId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETMACHINEINASSIGNEDBYMACHINEID);
    url += `?machineId=${machineId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function deleteMachineInAssignedById(Id) {
    const requestOptions = {
        method: 'DELETE', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_DELETEMACHINEINASSIGNEDBYID);
    url += `${Id}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getMachinesWithScissorStatusInfo() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_MACHINESWITHSCISSORSTATUSINFO);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getMachineByCode(machineCode) {
    console.log("getting machine by code:", machineCode)
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETMACHINEBYCODE);
    url += `?machineCode=${machineCode}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function updateZones(metaData, productionOrderId, machineIdPlanned) {

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify({
            productionOrderId: productionOrderId,
            metaData: metaData,
            machineIdPlanned: machineIdPlanned
        })
    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_UPDATEZONES);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function startProductionOrderLine(productionOrderLineId, selectedWorkstation, packer) {

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify({
            ProductionOrderLineId: productionOrderLineId,
            MachineId: selectedWorkstation,
            Packer: packer
        })

    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_STARTPRODUCTIONORDER);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function pauseProductionOrderLine(productionOrderLineId, packer) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify({
            ProductionOrderLineId: productionOrderLineId,
            Packer: packer
        })

    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_PAUSEPRODUCTIONORDER);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function stopProductionOrderLine(productionOrderLineId, machineId, reasonId, stopComment, packer) {

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify({
            ProductionOrderLineId: productionOrderLineId,
            MachineId: machineId,
            ReasonId: reasonId,
            Comment: stopComment,
            Packer: packer
        })

    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_STOPPRODUCTIONORDER);

    console.log(JSON.stringify(requestOptions))
    console.log(url)

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function finishProductionOrderLine(productionOrderLineId, packer) {

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify({
            ProductionOrderLineId: productionOrderLineId,
            Packer: packer
        })

    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_FINISHPRODUCTIONORDER);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getProductionOrderLineBOMOutProducedByBOMOutId(bomOutId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETPRODUCTIONORDERLINEBOMOUTPRODUCED);
    url += `?bomOutId=${bomOutId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function createBookingForProductionOrder(productionOrder, barcode, progress, stackingHeight, machineId) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify({
            ProductionOrderId: productionOrder.id,
            ProductionOrderLineId: productionOrder.orderLineId,
            Barcode: barcode,
            Progress: progress,
            StackingHeight: parseFloat(stackingHeight),
            MachineId: machineId
        })
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_CREATEBOOKING);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getMachineSettingsByMachineId(machineId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETMACHINESETTINGSBYMACHINEID);
    url += `?machineId=${machineId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function saveMachineSetting(machineId, value, machineSettingId) {

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify({
            MachineId: machineId,
            MachineSettingId: machineSettingId,
            Value: value
        })
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_SAVEMACHINESETTINGS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getQualitySamplesByBarcode(barcode, productionOrderId, productId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETQUALITYSAMPLESBYBARCODE);
    url += `?barcode=${barcode}`;
    url += `&productionOrderId=${productionOrderId}`;
    url += `&productId=${productId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function saveQualitySamples(qualitySamples, productionOrderId, machineCode, criticaloverride, criticalreason, criticalSample) {
    console.log(JSON.stringify({
        CarrierId: qualitySamples.carrierId,
        ProductionOrderId: productionOrderId,
        Criticaloverride: criticaloverride,
        Criticalreason: criticalreason,
        CriticalSample: criticalSample,
        QualitySamples: qualitySamples.qualitySamples,
        MachineCode: machineCode
    }))

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify({
            CarrierId: qualitySamples.carrierId,
            ProductionOrderId: productionOrderId,
            Criticaloverride: criticaloverride,
            Criticalreason: criticalreason,
            CriticalSample: criticalSample,
            QualitySamples: qualitySamples.qualitySamples,
            MachineCode: machineCode
        })
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_SAVEQUALITYSAMPLES);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch((error) => {
            console.error("Error saving samples:", error);
            return Promise.reject(error);
        });
}

function getQualitySamplesByProductionOrderId(productionOrderId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETQUALITYSAMPLESBYPRODUCTIONORDER);
    url += `?productionOrderId=${productionOrderId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function machineStoppedReason(lineNumber, reasonId, machineReasonDescription, userName) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify({
            LineNumber: lineNumber,
            ReasonId: reasonId,
            UserName: userName,
            MachineReasonDescription: machineReasonDescription
        })
    };

    let url = apiHelper.ComposeInterfaceUri(apiHelper.API_ACTION_MACHINESTOPPEDREASON);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function machineStoppedReasonNodeRED(lineNumber, reasonId, machineReasonDescription, userName) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            lineNumber: lineNumber,
            reasonId: reasonId,
            userName: userName,
            machineReasonDescription: machineReasonDescription,
            stopReasonKnown: true
        })
    };

    let url = apiHelper.ComposeNodeRedUri(apiHelper.API_ACTION_MACHINEREASONKNOWN_NODE_RED);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function saveOPCNotification(articleDescription, palletNumber, lineNumber, sequence, orderNumber) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            articleDescription: articleDescription,
            sequence: sequence,
            lineNumber: lineNumber,
            palletNumber: palletNumber,
            orderNumber: orderNumber
        })
    };

    let url = apiHelper.ComposeNodeRedUri(apiHelper.API_ACTION_SAVE_OPC_NOTIFICATION);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function saveNotification(notificationTypeId, barcode, machineId, machineCode, sampleSequence, productionOrderRef, sampleId, sampleCode, systemMessageId, message) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify({
            NotificationTypeId: notificationTypeId,
            SystemMessageId: systemMessageId,
            Message: message,
            Reference: {
                CarrierBarcode: barcode,
                MachineId: machineId,
                MachineCode: machineCode,
                CheckNumber: sampleSequence,
                SampleId: sampleId,
                SampleCode: sampleCode,
                ProductionOrderReference: productionOrderRef
            }
        })
    };
console.log(notificationTypeId, barcode, machineId, machineCode, sampleSequence, productionOrderRef, sampleId, sampleCode, systemMessageId, message)
    let url = apiHelper.ComposeInterfaceUri(apiHelper.API_ACTION_SAVENOTIFICATION);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getLatestNotifications(languageId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETLATESTNOTIFICATIONS);
    url += `?languageId=${languageId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function GetCheckNumberForPallet(barcode) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETCHECKNUMBERFORPALLET);
    url += `?barcode=${barcode}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function GetBookingSequenceByProductionOrderIdAndBarcode(productionOrderId, barcode) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETBOOKINGSEQUENCE);
    url += `?productionOrderId=${productionOrderId}`;
    url += `&barcode=${barcode}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function GetLastWeight() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeInterfaceUri(apiHelper.API_ACTION_GETLASTWEIGHT);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function validateAndHasRole(username, password, roles) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify({
            username: username,
            password: Base64.btoa(password),
            roles: roles
        })
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_VALIDATEANDHASROLE);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getArticleInfoByBarcode(barcode) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETARTICLEINFOBYBARCODE);
    url += `?barcode=${barcode}`

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getProductionOrderLineStateHistory(productionOrderLineId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_ORDERLINEHISTORY);
    url += `?productionOrderLineId=${productionOrderLineId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getAllUsersWithDetails() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLUSERSWITHDETAILS);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getAllRoles() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETALLROLES);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function saveUser(user) {

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify(user)
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_SAVEUSER);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

//Fake backend Calls
function getMaterials() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetMaterials', requestOptions).then(handleResponse);
}

function getArticles() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetArticles', requestOptions).then(handleResponse);
}

function pauseOrderById(id) {
    const requestOptions = { method: 'PUT' };
    return fetch('/Api/PauseOrderById?id=' + id, requestOptions).then(handleResponse);
}

function startOrderById(id) {
    const requestOptions = { method: 'PUT' };
    return fetch('/Api/StartOrderById?id=' + id, requestOptions).then(handleResponse);
}

function getActiveTransportOrders() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetActiveTransportOrders', requestOptions).then(handleResponse);
}

function getTransportOrdersHistory() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetTransportOrdersHistory', requestOptions).then(handleResponse);
}

function createNewBooking(newBooking) {
    const requestOptions = {
        method: 'POST', headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
        },
        body: newBooking
    };
    return fetch('/Api/CreateNewBooking', requestOptions).then(handleResponse);
}

function getOperators() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetOperators', requestOptions).then(handleResponse);
}

function getMachineParameters() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetMachineParameters', requestOptions).then(handleResponse);
}

function getMachinesByMachineType(machineType) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_MACHINESBYMACHINETYPE);
    url += `?machineTypeId=${machineType}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getSilos() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetSilos', requestOptions).then(handleResponse);
}

function getQualityChecks() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetQualityChecks', requestOptions).then(handleResponse);
}

function getQualityCheckTypes() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetQualityCheckTypes', requestOptions).then(handleResponse);
}

function getQualityCheckOrders() {
    const requestOptions = { method: 'GET' };
    return fetch('/Api/GetQualityCheckOrders', requestOptions).then(handleResponse);
}

export function resyncOrders(user) {

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify(user)
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_RESYNCORDERS);
    console.log(url, 'resync in progress')
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function restartScale(scale) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_RESTARTSCALE);
    url += `?scale=${scale}`;
    return fetch(url, requestOptions).then(handleResponse);
}

function restartRecycleScale(scale) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_RESTARTRECYCLESCALE);
    url += `?scale=${scale}`;
    return fetch(url, requestOptions).then(handleResponse);
}

function saveZoneDivisions(zoneUpdateModel) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify(zoneUpdateModel)
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_SAVEZONEDIVISIONS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getZoneDivisions(orderLineId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETZONEDIVISIONS);
    url += `?orderLineId=${orderLineId}`;
    return fetch(url, requestOptions).then(handleResponse);
}

function getWeightForLineNumber(machineNumber) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeInterfaceUri(apiHelper.API_ACTION_GETWEIGHTFORLINENUMBER);
    url += `?machineNumber=${machineNumber}`;
    return fetch(url, requestOptions).then(handleResponse);
}

function getWeightForRecycle(machineNumber) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeInterfaceUri(apiHelper.API_ACTION_GETWEIGHTFORRECYCLE);
    url += `?machineNumber=${machineNumber}`;
    return fetch(url, requestOptions).then(handleResponse);
}

function switchRawMaterialForOrder(productionOrderLineId, switchPercentage, hasReplacementMaterial = true) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_SWITCHRAWMATERIAL);
    url += `?productionOrderLineId=${productionOrderLineId}`;
    url += `&switchPercentage=${switchPercentage}`;
    url += `&hasReplacementMaterial=${hasReplacementMaterial}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function GetOriginalRawMaterialBoms(OrderId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETORIGINALRAWMATERIALBOMS);
    url += `?OrderId=${OrderId}`;

    return fetch(url, requestOptions).then(handleResponse);
}

function GetIsBookingCritical(OrderId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETISBOOKINGCRITICAL);
    url += `?OrderId=${OrderId}`;

    return fetch(url, requestOptions).then(handleResponse);
}

function LogStandStillStart(type, supervisor, machineCode) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_LOGSTANDSTILLSTART);
    url += `?type=${type}`;
    url += `&supervisor=${supervisor}`;
    url += `&machineCode=${machineCode}`;

    return fetch(url, requestOptions).then(handleResponse);
}

function LogStandStillStop(type, supervisor, machineCode, nieuwefilter, reservefilter, kuisenfilter, gaatjes, reinigen, gaatjesVrijmaken, mondstuk, beentjes, gaatesUitstekken, lippen, elektroden, mesjes, uitvoerrollen, restenUithalen, opkuisMachine, reinigenSchema, remark) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_LOGSTANDSTILLSTOP);
    url += `?type=${type}`;
    url += `&supervisor=${supervisor}`;
    url += `&machineCode=${machineCode}`;
    url += `&nieuwefilter=${nieuwefilter}`;
    url += `&reservefilter=${reservefilter}`;
    url += `&kuisenfilter=${kuisenfilter}`;
    url += `&gaatjes=${gaatjes}`;
    url += `&reinigen=${reinigen}`;
    url += `&gaatjesVrijmaken=${gaatjesVrijmaken}`;
    url += `&mondstuk=${mondstuk}`;
    url += `&beentjes=${beentjes}`;
    url += `&gaatesUitstekken=${gaatesUitstekken}`;
    url += `&lippen=${lippen}`;
    url += `&elektroden=${elektroden}`;
    url += `&mesjes=${mesjes}`;
    url += `&uitvoerrollen=${uitvoerrollen}`;
    url += `&restenUithalen=${restenUithalen}`;
    url += `&opkuisMachine=${opkuisMachine}`;
    url += `&reinigenSchema=${reinigenSchema}`;
    url += `&remark=${remark}`;

    return fetch(url, requestOptions).then(handleResponse);
}

function GetStopReasons() {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETSTOPREASONS);

    return fetch(url, requestOptions).then(handleResponse);

}

function getProductionStateByMachineId(machineId) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETPRODUCTIONSTATEBYMACHINEID);
    url += `?machineId=${machineId}`;
    return fetch(url, requestOptions).then(handleResponse);
}

function updateProductionStateOrderLog(productionStateOrder) {
    console.log(productionStateOrder);
    const requestOptions = {
        method: 'PUT', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify(productionStateOrder)
    };
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_UPDATEPRODUCTIONORDERSTATUSLOG);
    return fetch(url, requestOptions).then(handleResponse);
}

function getScrapColors() {
    const requestOptions = { 
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETSCRAPCOLORS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getScrapCarrierTypes() {
    const requestOptions = { 
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETSCRAPCARRIERTYPES);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getScrapMaterialTypes() {
    const requestOptions = { 
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETSCRAPMATERIALTYPES);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getRecyclingHistory() {
    const requestOptions = { 
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETRECYCLINGHISTORY);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function postRecyclingHistoryEntry(recyclingHistoryEntry) {
    console.log("posting recycling entry", recyclingHistoryEntry);
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify(recyclingHistoryEntry)
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_POSTRECYCLINGHISTORYENTRY);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch((error) => {
            console.error("Error posting recycling entry:", error);
            return Promise.reject(error);
        });
}

function carrierExists(barcode) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_CARRIEREXISTS);
    url += `?barcode=${barcode}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function getWasteLocations() {
    const requestOptions = { 
        method: 'GET', headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETWASTELOCATIONS);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

function addOperatorCommentToOrderlineMetaData(orderLineId, comment, operatorId) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        },
        body: JSON.stringify({
            ProductionOrderLineId: orderLineId,
            Comment: comment,
            OperatorId: operatorId
        })
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_ADDOPERATORCOMMENT);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch((error) => {
            console.error("Error adding operator comment:", error);
            return Promise.reject(error);
        });
}

function getOperatorComments(productionOrderLineId) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': apiHelper.getAuthHeader()
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETOPERATORCOMMENTS) + `?productionOrderLineId=${productionOrderLineId}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch((error) => {
            console.error("Error getting operator comments:", error);
            return Promise.reject(error);
        });
}
